import Vue from 'vue'
import Vuetify, {
  VApp, // required
  VMain
} from 'vuetify/lib'

Vue.component('v-app', VApp);
Vue.component('v-main', VMain);
Vue.use(Vuetify)

const opts = {}

export default new Vuetify(opts)
